import http from 'hub-http/clients/apiClient';
export const SlowRolloutAPI = {
  fetchIsOptedIn: () => http.get(`rollouts-app/v2/slow-rollouts/is-opted-in`)
};